<template>
  <div class="container mt-md-5 col-md-6 p-4">
    <div class="row">
      <h2 class="text-uppercase">{{ $t('gameTypeSelection.selectGameType') }}</h2>
      <div class="d-grid">
        <button @click="selectGameType('league')" class="btn btn-bb5-yellow m-0 p-2 my-2">{{ $t('gameTypeSelection.league') }}</button>
        <button @click="selectGameType('tournament')" class="btn btn-bb5-yellow m-0 p-2 my-2">{{ $t('gameTypeSelection.tournament') }}</button>
        <button @click="selectGameType('single')" class="btn btn-bb5-yellow m-0 p-2 my-2">{{ $t('gameTypeSelection.single') }}</button>
        <button v-if="hasSavedGames" @click="continueGameHandler" class="btn btn-bb5-yellow m-0 p-2 my-2">{{ $t('gameTypeSelection.continue') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: 'GameTypeSelection',
  data() {
    return {
      hasSavedGames: false, // Zustand, ob Spiele vorhanden sind
    };
  },
  async mounted() {
    this.hasSavedGames = localStorage.getItem('currentgame');
  },
  methods: {
    ...mapActions(['setGameType', 'setGame', 'checkSavedGames', 'continueGame', 'resetGame']),
    selectGameType (type) {
      this.resetGame();
      this.setGameType(type)
      this.$router.push('/team');
    },
    async continueGameHandler() {
      const gameId = localStorage.getItem('currentgame');
      await this.continueGame(gameId);
      this.$router.push('/game');
    },

  }
};
</script>

<style scoped>
</style>
